import React from 'react'
import PdfViewer from '../../../components/pdf-viewer/pdfViewer'
const CandidatePfd = ({ pdfUrl }) => {
    return (
        <div>
            <PdfViewer pdfUrl={pdfUrl} />
        </div>
    )
}

export default CandidatePfd
